import { LocationType } from '../utils/parseAddress';
import React, { useState, useEffect } from "react";
import { initialData } from "../consts/home";
import { api } from "../services/api";
import { toast } from 'react-toastify';
import ShoppingCart from '../assets/shopping_cart.svg';
import { Retailer } from '../types/retailer';

const useHome = () => {
  const [data, setData] = useState(initialData);
  const [selected, setSelected] = useState(0);
  const [cigarSelected, setCigarSelected] = useState(0);
  const [stats, setStats] = useState<any>(null);
  const [loader, setLoder] = useState(false);
  const [topCigars, setTopCigars] = useState<any>(null);
  // const [last90Days, setLast90Days] = useState<any>(null);
  const [last30Days, setLast30Days] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [locations, setLocations] = useState<LocationType[]>([]);
  const [allCigarData, setAllCigarData] = useState<any[]>([]);
  const [filter, setFilter] = React.useState('all')
  const [selectedFromMarker, setSelectedFromMarker] = useState<number>(0);
  const [selectedRetailer, setSelectedRetailer] = useState<number>(0);
  const [retailers, setRetailers] = useState<Retailer[]>([]);
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [timelineTotalRecords, setTimelineTotalRecords] = useState<number>(0);
  const [selectedTimelinePage, setSelectedTimelinePage] = useState<number>(1);
  const [showTimelineView, setShowTimelineView] = useState<boolean>(false);
  const [communityChallenges, setCommunityChallenges] = useState<any[]>([]);
  const [communityProgress, setCommunityProgress] = useState<number>(0);
  const filterOptions = [
    { value: 'all', label: 'All Cigars' },
    { value: 'user', label: 'User Cigars' },
    { value: 'retailer', label: 'Retailers' }
  ]


  const handleFilterChange = (value: string) => {
    setFilter(value)
    console.log('Filter:', value)
  }


  useEffect(() => {
    const fetchData = async () => {
      setLoder(true);
      try {
        await fetchCommunityChallenges();

        if (filter === 'retailer') {
          // Load lightweight retailer data for map markers only
          const retailerStartTime = performance.now();
          const retailersData = await api.retailers.getRetailersForMap();
          const retailerEndTime = performance.now();
          console.log(`⏱️ Retailer Map Data Loading Time: ${((retailerEndTime - retailerStartTime) / 1000).toFixed(2)}s`);

          console.log("Retailers Map Data", retailersData);
          // Map retailers to LocationType for map display
          setLocations(retailersData.map((retailer: any) => ({
            name: retailer.name,
            latitude: retailer.latitude,
            longitude: retailer.longitude,
            id: retailer.id,
            picture: '/images/store.png'
          })));
        }
        else {
          const totalStartTime = performance.now();

          // Load stats first
          const statsStartTime = performance.now();
          const statsResponse = await api.stats.getStats();
          const statsEndTime = performance.now();
          console.log(`⏱️ Stats Loading Time: ${((statsEndTime - statsStartTime) / 1000).toFixed(2)}s`);
          console.log("STAT triggered", statsResponse);
          setStats(statsResponse);

          // Then load leaderboard data
          const leaderboardStartTime = performance.now();
          const [topCigarsResponse, ninetyDaysResponse] = await Promise.all([
          api.stats.getTopCigars(),
          api.stats.get30DayStats(),
        ]);
          const leaderboardEndTime = performance.now();
          console.log(`⏱️ Leaderboard Loading Time: ${((leaderboardEndTime - leaderboardStartTime) / 1000).toFixed(2)}s`);
          setTopCigars(topCigarsResponse);
          setLast30Days(ninetyDaysResponse);

          // Finally load map data (lightweight version for markers only)
          const mapStartTime = performance.now();
          const cigarsResponse = await api.cigars.listCigarsForMap(filter);
          const mapEndTime = performance.now();
          console.log(`⏱️ Map Data Loading Time: ${((mapEndTime - mapStartTime) / 1000).toFixed(2)}s`);

          console.log("Map Cigars Response", cigarsResponse);

          const mappedLocations = cigarsResponse.map((cigar: any) => ({
            ...cigar,
            picture: cigar.user_profile_picture || cigar.picture,
            name: cigar.product_name || cigar.name
          }));

          // Store lightweight map data as locations
          setLocations(mappedLocations);

          const totalEndTime = performance.now();
          console.log(`🏁 Total Loading Time: ${((totalEndTime - totalStartTime) / 1000).toFixed(2)}s`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("An error occurred while fetching data. Please try again.");
      } finally {
        setLoder(false);
        console.log("Locations", locations);
      }
    };

    fetchData();
  }, [filter]);

  const fetchCommunityChallenges = async () => {
    try {
      const response = await api.rewards.getCommunityChallenges();
      setCommunityChallenges(response);
      const total = response.reduce((sum: number, challenge: { progress_percentage: number }) =>
        sum + (challenge.progress_percentage || 0), 0);

      if (response.length > 0) {
        setCommunityProgress(Math.round(total / response.length));
      }
    } catch (error) {
      console.error('Error fetching community challenges:', error);
    }
  }

  const handleMarkerClick = async (id: number) => {
    console.log("Filter", filter);
    if (filter === 'retailer') {
      console.log("Retailer clicked", id);
      setSelected(0);
      setCigarSelected(0);
      setSelectedFromMarker(0);
      setSelectedRetailer(id);

      // Check if we already have the full details for this retailer
      const existingRetailer = retailers.find((retailer: any) => retailer.id === id);
      if (existingRetailer) {
        console.log("Retailer details already loaded from cache");
        return;
      }

      // Fetch full details for this specific retailer only
      try {
        console.log("Fetching full retailer details for ID:", id);
        const detailStartTime = performance.now();
        const retailerDetail = await api.retailers.getRetailerDetail(id);
        const detailEndTime = performance.now();
        console.log(`⏱️ Single Retailer Detail Loading Time: ${((detailEndTime - detailStartTime) / 1000).toFixed(2)}s`);

        if (retailerDetail) {
          setRetailers((prev) => [...prev, retailerDetail]);
        }
      } catch (error) {
        console.error("Error fetching retailer details:", error);
        toast.error("Failed to load retailer details. Please try again.");
      }
      return;
    }
    console.log("Marker clicked", id);
    setSelected(0);
    setCigarSelected(0);
    setSelectedFromMarker(id);
    setSelectedRetailer(0);

    // Check if we already have the full details for this cigar
    const existingCigar = allCigarData.find((cigar: any) => cigar.id === id);
    if (existingCigar) {
      console.log("Cigar details already loaded from cache");
      return;
    }

    // Fetch full details for this specific cigar only
    try {
      console.log("Fetching full cigar details for ID:", id);
      const detailStartTime = performance.now();
      const cigarDetail = await api.cigars.getCigarDetail(id);
      const detailEndTime = performance.now();
      console.log(`⏱️ Single Cigar Detail Loading Time: ${((detailEndTime - detailStartTime) / 1000).toFixed(2)}s`);

      if (cigarDetail) {
        setAllCigarData((prev) => [...prev, cigarDetail]);
      }
    } catch (error) {
      console.error("Error fetching cigar details:", error);
      toast.error("Failed to load cigar details. Please try again.");
    }
  };

  const toggleDataDisplay = () => {
    setData((prev) =>
      prev.length > 5 ? initialData : [...prev, ...prev]
    );
  };

  const onSelectUser = (id: number) => {
    let user = topCigars.find((user: any) => user.id === id);
    console.log("User on Selected", user, id, topCigars);
    setSelectedUser(user);
    setSelected(id);
  };

  const refreshData = async () => {
    setLoder(true);
    setSelected(0);
    try {
      await fetchCommunityChallenges();
      const [topCigarsResponse, thirtyDaysResponse] = await Promise.all([
        api.stats.getTopCigars(),
        api.stats.get30DayStats(),
      ]);
      setTopCigars(topCigarsResponse);
      setLast30Days(thirtyDaysResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data. Please try again.");
    } finally {
      setLoder(false);
    }
  };

  const getTimelineData = async (page = 1) => {
    const itemPerPage = 5;
    setLoder(true)
    setTimelineData([]);
    setSelectedTimelinePage(page);
    try {
      const response = await api.stats.getTimeline(selectedTimelinePage, itemPerPage);
      console.log("Timeline Response", response);
      const transformedData = response.results.map((entry: any) => ({
        id: entry.id,
        title: entry.product_name,
        points: entry.product_points,
        created_at: entry.created_at,
        picture: entry.product_picture,
        experience_note: entry.experience_note,
        description: entry.user_name,
      }));

      setTimelineData(transformedData);
      setTimelineTotalRecords(Math.ceil(response.count / itemPerPage));
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data. Please try again.");
    } finally {
      setLoder(false);
    }
  }

  const getTimelineRewardHistoryData = async (page = 1) => {
    const itemsPerPage = 5;
    setLoder(true);
    setTimelineData([]);
    setSelectedTimelinePage(page);

    try {
      const response = await api.rewards.getRedemptionHistory(page, itemsPerPage);
      console.log("Reward History Response", response);
      const transformedData = response.results.map((entry: any) => ({
        id: entry.id,
        title: entry.reward_name,
        points: entry.points,
        created_at: entry.aquired_on,
        picture: entry.picture,
        description: entry.description,
      }));

      setTimelineData(transformedData);
      setTimelineTotalRecords(Math.ceil(response.count / itemsPerPage));
    } catch (error) {
      console.error("Error fetching reward history data:", error);
      toast.error("An error occurred while fetching reward history. Please try again.");
    } finally {
      setLoder(false);
    }
  };

  const onUserClick = async (userId: string) => {
    try {
      const response = await api.users.getMemberInfo(userId);
      console.log("User Click Response", response);
      setSelectedUser(response);
      setSelected(parseInt(userId));
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("An error occurred while fetching user data. Please try again.");
    }
  }

  return {
    data,
    selected,
    cigarSelected,
    stats,
    loader,
    topCigars,
    last30Days,
    selectedUser,
    locations,
    toggleDataDisplay,
    onSelectUser,
    setSelected,
    refreshData,
    filter,
    filterOptions,
    handleFilterChange,
    handleMarkerClick,
    selectedFromMarker,
    setSelectedFromMarker,
    selectedRetailer,
    setSelectedRetailer,
    retailers,
    allCigarData,
    getTimelineData,
    timelineData,
    setTimelineData,
    timelineTotalRecords,
    selectedTimelinePage,
    getTimelineRewardHistoryData,
    showTimelineView,
    setShowTimelineView,
    onUserClick,
    communityChallenges,
    communityProgress
  };
};

export default useHome;
